export default __webpack_public_path__ + "static/edit-task-317fe40fe83ca2600a99ed9988effa40.png";